import App from '@modules/husleie-framework/src/static-classes/App.class.js';
import Vue from 'vue';
import Router from 'vue-router';
import Bruker from './views/Bruker.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: App.getPublicPath(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Bruker,
      meta: {
        title: 'signup.routes.landlord.user',
      }
    },
    {
      path: '/landlord',
      name: 'landlord',
      meta: {
        title: 'signup.routes.landlord.landlord',
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ './views/Utleier.vue')
    },
    {
      path: '/rental-object',
      name: 'object',
      meta: {
        title: 'signup.routes.landlord.rental object',
      },
      component: () => import ('./views/Leieobjekt.vue')
    },
    {
      path: '/verify',
      name: 'verify',
      meta: {
        hiddenFromProgress: true,
      },
      component: () => import ('./views/Verify.vue')
    },
    {
      path: '/choose',
      name: 'choose',
      meta: {
        title: 'signup.routes.landlord.choose',
      },
      component: () => import ('./views/Velg.vue')
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
});

router.beforeEach((to, from, next) => {
  if (to.fullPath.substr(0, 2) === '/#') {
    const path = to.fullPath.substr(2);
    next({ path, replace: true });
    return;
  }
  next();
});

export default router;
